// Telefonnummer: Klick ruft über die Telefonie an (useTelefonie().anrufen), daneben Kopierknopf.
// Ist die Telefonie nicht eingerichtet, wird die Nummer kopiert und das gesagt.
import { useTelefonie } from "../telefonie";
import { kopieren } from "../werkzeuge/tasten";
import { telefonText } from "../werkzeuge/telefon";
import { KopierKnopf } from "./Bausteine";
import { Icon } from "./Icon";
import { useMeldung } from "./Meldungen";
import type { AnrufenMitNamen } from "./TelefonieTeile";

const TYPEN: Record<string, string> = {
  mobile: "Mobil",
  office: "Büro",
  direct: "Durchwahl",
  home: "Privat",
  fax: "Fax",
  other: "Sonstige",
};

export function telefonTyp(typ: string | null | undefined): string {
  return typ ? TYPEN[typ] ?? typ : "";
}

export { telefonText };

export function useAnrufen() {
  const tel = useTelefonie();
  const meldung = useMeldung();
  return async (nummer: string, leadId: string, contactId?: string | null, namen?: { leadName?: string | null; kontaktName?: string | null }) => {
    if (tel.status === "nicht_eingerichtet") {
      const kopiert = await kopieren(nummer);
      meldung.zeige("info", `${tel.grund ?? "Telefonie ist nicht bereit."}${kopiert ? " Nummer kopiert." : ""}`, { label: "Einstellungen", to: "/einstellungen#telefonie" });
      return;
    }
    try {
      await (tel.anrufen as AnrufenMitNamen)(nummer, leadId, contactId ?? undefined, namen);
    } catch (e) {
      meldung.fehler(e, "Anruf nicht gestartet");
    }
  };
}

interface Props {
  nummer: string;
  formatiert?: string | null;
  typ?: string | null;
  leadId: string;
  contactId?: string | null;
  kompakt?: boolean;
  leadName?: string | null;
  kontaktName?: string | null;
}

export function Telefonnummer({ nummer, formatiert, typ, leadId, contactId, kompakt = false, leadName, kontaktName }: Props) {
  const anrufen = useAnrufen();
  const tel = useTelefonie();
  const bereit = tel.status !== "nicht_eingerichtet";
  const text = telefonText(nummer, formatiert);
  return (
    <span className={`telefon${kompakt ? " telefon--kompakt" : ""}`}>
      <button
        type="button"
        className="telefon__knopf"
        title={bereit ? `Anrufen: ${text}` : `${tel.grund ?? "Telefonie nicht bereit"} Klick kopiert die Nummer.`}
        onClick={(e) => {
          e.stopPropagation();
          void anrufen(nummer, leadId, contactId, { leadName, kontaktName });
        }}
      >
        <Icon name="telefon" groesse={14} />
        <span className="telefon__nummer">{text}</span>
      </button>
      {typ && !kompakt ? <span className="telefon__typ">{telefonTyp(typ)}</span> : null}
      <KopierKnopf text={nummer} label="Nummer kopieren" />
    </span>
  );
}
